import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend } from 'src/config'

export const fetchRegistries = createAsyncThunk(
  'FETCH_REGISTRIES',
  async (
    { page = 1, offset = 10000, enqueueSnackbar },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        `${backend}/api/sending-registry/data?offset=${offset}&page=${page}`
      )
      return response.data
    } catch (error) {
      enqueueSnackbar(error.message || error, {
        variant: 'error',
      })
      return rejectWithValue([], error)
    }
  }
)

export const fetchOneRegistry = createAsyncThunk(
  'FETCH_ONE_REGISTRY',
  async ({ id, enqueueSnackbar }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${backend}/api/sending-registry/${id}`)
      return response.data
    } catch (error) {
      enqueueSnackbar(error.message || error, {
        variant: 'error',
      })
      return rejectWithValue([], error)
    }
  }
)

export const sendRegistryToCustoms = createAsyncThunk(
  'SEND_CUSTOMS',
  async ({ registryId, enqueueSnackbar }, { rejectWithValue }) => {
    try {
      if (!registryId) return
      const response = await axios.post(
        `${backend}/api/unitrade/register/${registryId}`
      )
      enqueueSnackbar('Данные успешно отправлены на таможню', {
        variant: 'success',
      })
      return response.data
    } catch (error) {
      enqueueSnackbar('Данные не отправлены', {
        variant: 'error',
      })
      return rejectWithValue([], error)
    }
  }
)

export const sendRegistryToCustomsShipment = createAsyncThunk(
  'SEND_CUSTOMS_SHIPMENT',
  async ({ shipmentId, enqueueSnackbar }, { rejectWithValue }) => {
    try {
      if (!shipmentId) return
      const response = await axios.post(
        `${backend}/api/unitrade/register/shipment/${shipmentId}`
      )
      enqueueSnackbar('Данные успешно отправлены на таможню', {
        variant: 'success',
      })
      return response.data
    } catch (error) {
      enqueueSnackbar('Данные не отправлены', {
        variant: 'error',
      })
      return rejectWithValue([], error)
    }
  }
)
